import React from "react";
import PictureSectionWithCaption from "components/common/PictureSectionWithCaption";
import BaseIntroSection from "../../common/BaseIntroSection";

import Post1 from "./assets/hyr_1.jpg";
import Post2 from "./assets/hyr_2.jpg";
import Post3 from "./assets/hyr_3.jpg";
import Post4 from "./assets/hyr_4.jpg";
import Post5 from "./assets/hyr_5.jpg";
import Post6 from "./assets/hyr_6.jpg";

import Post1_2x from "./assets/2x/hyr_1.jpg";
import Post2_2x from "./assets/2x/hyr_2.jpg";
import Post3_2x from "./assets/2x/hyr_3.jpg";
import Post4_2x from "./assets/2x/hyr_4.jpg";
import Post5_2x from "./assets/2x/hyr_5.jpg";
import Post6_2x from "./assets/2x/hyr_6.jpg";

import "./HowYouRankPageSections.scss";

const RedQuote = () => (
	<div className="redQuote text-align-center desktop-max-width-small font-family-open-sans-italic font-size-xlarge">
		<div className="quote">
			“Those [features] prompt you to really perfect your profile and build yourself up and make yourself appear how you want to be. So I see it as building yourself, your brand.”
		</div>
		- LinkedIn Member
	</div>
);

export const RankIntroSection = () => (
	<BaseIntroSection
		className="checkoutPage"
		mainText="LinkedIn How You Rank"
		subText="Helping our members stand out from the crowd and get found on LinkedIn"
		aboutText="In 2014, LInkedIn’s How You Rank was launched to be a compliment product to the very popular Who’s Viewed your Profile tool and was designed as a Premium [paid] product. As an extension to the Who’s Viewed My Profile tool, our goal was to help members see who might be getting more views in their industry, network, company, and get a better understanding of what may contribute to higher profile views. While developing the product, I worked closely with with Product Manager and UX Researcher to understand this space. The biggest challenge in this product was trying to create something meaningful and useful and at the same time, trying to not hurt member feelings if they happen to rank low but also provide insights what they can do to increase profile views."
	>
		<RedQuote />
	</BaseIntroSection>
);

export const RankMainContent = () => ([
	<PictureSectionWithCaption
		imageSrc={Post1}
		imageSrc2x={Post1_2x}
		className="has-grey-background"
		key={1}
	/>,
	<PictureSectionWithCaption
		imageSrc={Post2}
		imageSrc2x={Post2_2x}
		caption="LinkedIn Premium upsell designs"
		additionalImages={[
			{
				imageSrc: Post3,
				imageSrc2x: Post3_2x
			}, {
				imageSrc: Post4,
				imageSrc2x: Post4_2x
			}
		]}
		key={2}
	/>,
	<PictureSectionWithCaption
		imageSrc={Post5}
		imageSrc2x={Post5_2x}
		caption="Locked How you rank design"
		key={3}
	/>,
	<PictureSectionWithCaption
		imageSrc={Post6}
		imageSrc2x={Post6_2x}
		caption="Unlocked Premium version of How You Rank"
		key={4}
	/>,
]);



// WEBPACK FOOTER //
// ./src/components/pages/howYouRank/HowYouRankPageSections.js